/* M2L Digital Studios - portfolio grid: cards stack into a deck as you scroll.

   Built entirely on native CSS position:sticky. Each card parks in the viewport
   at a slightly lower offset than the one before, so the deck builds up with
   every card's top edge peeking out.

   Deliberately there is NO scroll-linked JavaScript here - no scroll listener,
   no scrubbed animation, nothing that runs per frame. iOS Safari scrolls on the
   compositor thread while JavaScript runs on the main thread, so anything that
   writes transforms from scroll events lags behind the scroll and makes the
   cards visibly shudder. Sticky is handled by the browser itself, so the stack
   stays glued to the scroll no matter how fast you flick it.

   JavaScript is used only to measure the layout once and write each card's
   sticky offset, plus recompute it if the viewport genuinely changes shape. */
(function () {
  'use strict';

  var NARROW_QUERY = '(max-width: 900px)'; // .project-card collapses to one column here
  var PEEK_DESKTOP = 18;   // vertical reveal between stacked cards
  var PEEK_NARROW = 12;    // tighter, since single-column cards are much taller
  var MIN_PAD = 16;        // smallest allowed breathing room below the fixed header
  var MIN_SLACK = 120;     // spare viewport height required before stacking is worthwhile

  function peek() {
    return window.matchMedia(NARROW_QUERY).matches ? PEEK_NARROW : PEEK_DESKTOP;
  }

  function headerHeight() {
    var header = document.querySelector('.m2l-header');
    return header ? header.offsetHeight : 0;
  }

  function tallest(cards) {
    return cards.reduce(function (max, c) { return Math.max(max, c.offsetHeight); }, 0);
  }

  // Total vertical space the assembled deck occupies.
  function deckHeight(cards) {
    return tallest(cards) + (cards.length - 1) * peek();
  }

  // Only stack when the deck fits with room to spare. Fitting exactly is not
  // enough: the window during which every card is simultaneously stuck is
  // proportional to that slack, so a deck that only just fits assembles for a few
  // pixels of scroll and reads as ordinary scrolling.
  function fits(cards) {
    return (window.innerHeight - headerHeight()) - deckHeight(cards) >= MIN_SLACK;
  }

  // Park the deck vertically centred in the space below the header rather than
  // tight against it. Falls back to MIN_PAD when space is tight.
  function stickyTop(cards, i) {
    var head = headerHeight();
    var centred = Math.round(head + (window.innerHeight - head - deckHeight(cards)) / 2);
    return Math.max(head + MIN_PAD, centred) + i * peek();
  }

  function initStack(cards) {
    function layout() {
      if (fits(cards)) {
        cards.forEach(function (card, i) {
          card.style.position = 'sticky';
          card.style.top = stickyTop(cards, i) + 'px';
          // DOM order stacking: each card that arrives settles over the one before it.
          card.style.zIndex = String(i + 1);
        });
      } else {
        cards.forEach(function (card) {
          card.style.position = '';
          card.style.top = '';
          card.style.zIndex = '';
        });
      }
    }
    layout();

    // Mobile browsers fire `resize` mid-scroll every time the address bar collapses
    // or expands - height changes by ~100px while the layout is otherwise identical.
    // Re-running layout there rewrites every sticky offset while the user is
    // scrolling, which visibly jolts the cards. So only react to a width change, or
    // to a height change far larger than any browser chrome (a real rotation).
    var TOOLBAR_SLOP = 200;
    var lastW = window.innerWidth;
    var lastH = window.innerHeight;
    var resizeTimer;
    function onResize() {
      var w = window.innerWidth;
      var h = window.innerHeight;
      if (w === lastW && Math.abs(h - lastH) <= TOOLBAR_SLOP) return;
      lastW = w;
      lastH = h;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layout, 150);
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
  }

  function boot() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-portfolio-stack]').forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-portfolio-stack-card]'));
      if (cards.length < 2) return;
      initStack(cards);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
